import {
  getFieldsByProjectId,
  selectActiveProject,
  selectProjectFields,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { FC } from 'react'
import { useEffect } from 'react'

import { Navigation, NotFoundWellInProject } from './components'
import { Steps } from './Steps'

export const SpeedLawsBody: FC = () => {
  const dispatch = useAppDispatch()
  const { id: projectId } = useAppSelector(selectActiveProject)
  const fields = useAppSelector(selectProjectFields)

  const hasFields = fields.length !== 0

  useEffect(() => {
    if (projectId !== '') {
      dispatch(getFieldsByProjectId(projectId))
    }
  }, [projectId])

  if (!hasFields) {
    return <NotFoundWellInProject />
  }

  return (
    <>
      <Navigation />
      <Steps projectId={projectId} />
    </>
  )
}
